import request from '@/utils/request'

const giftApiList = [
  // 获取名片申请详情
  ['loadCardDetails', 'POST', '/treasure/ehr/card/DoProcessInstance'],
  ['loadPersonalDetails', 'POST', '/treasure/ehr/personal/DoProcessInstance'],
  
]

let apiListMap = giftApiList.reduce((sum, prev) => {
  if (!prev || !prev[0] || !prev[1]) return sum
  sum[prev[0]] = prev
  return sum
}, {})

export function fetchData (apiName, payload) {
  const api = apiListMap[apiName]
  let options = {
        url: api[2],
        method: api[1],
        params :{
          "CurrentHrEmpId": payload.emplId
        },
        data: payload.data
      }
  return request(options)
}




